import {
  regexEmail,
  regexName,
  regexPhone,
  regexDate,
} from "../../helpers/regex";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { updateRecordInDb } from "../../controllers/editRecord";
import { IRecord } from "../../interfaces/interfaces";
import { useState, useEffect } from "react";
import { useRecords } from "../../hooks/useRecords";
import "./EditForm.css";

const SignupSchema = Yup.object().shape({
  name: Yup.string()
    .required("Se requiere nombre.")
    .min(4, "Se requieren 4 caracteres como mínimo.")
    .max(12, "Se aceptan hasta 12 caracteres.")
    .matches(regexName, "Solo se aceptan letras."),
  email: Yup.string()
    .required("Se requiere email.")
    .min(6, "Se requieren 6 caracteres como mínimo.")
    .max(35, "Se aceptan hasta 35 caracteres.")
    .matches(regexEmail, "Solo se aceptan emails."),
  phone: Yup.string()
    .required("Se requiere teléfono.")
    .min(8, "Se requieren 9 dígitos como mínimo.")
    .max(9, "Se aceptan hasta 9 dígitos.")
    .matches(regexPhone, "Solo se aceptan números."),
  date: Yup.string()
    .required("Se requiere fecha.")
    .matches(regexDate, "Solo fecha con formato dd/mm/yyyy."),
  _id: Yup.string()
    .required("Se requiere id")
});

const updateOneRecord = async (
  dataUpdate: IRecord,
  actions: any,
  editRecord: any
) => {
  let updatedRecord = await updateRecordInDb(dataUpdate);

  if (updatedRecord) {
    window.alert("The record was updated!");

    actions.resetForm();
    editRecord(updatedRecord);
  } else {
    window.alert("The record was not updated");
  }
};

const EditForm: React.FC<any> = () => {
  const { editForm, editRecord } = useRecords();

  const [data, setData] = useState<IRecord>(editForm);
  useEffect(() => {
    setData(editForm);
  }, [editForm]);

  const onChangeData = (e: any) => {
    let value = e.target.value;
    let name = e.target.name;
    setData({ ...data, [name]: value });
  };

  return (
    <div className="Form-box">
      <Formik
        initialValues={data}
        onSubmit={(values, actions) => {
          updateOneRecord(values, actions, editRecord);
        }}
        validationSchema={SignupSchema}
      >
        {({ errors, touched }) => (
          <Form onChange={(e: any) => onChangeData(e)}>
            <div className="Input-Edit-box">
              <label htmlFor="name">Nombre</label>
              <Field
                id="name"
                name="name"
                placeholder="Nombre"
                value={data.name}
              />
            </div>
            <div className="Input-error-box">
              {errors.name && touched.name ? <div>{errors.name}</div> : null}
            </div>
            <div className="Input-Edit-box">
              <label htmlFor="email">Email</label>
              <Field
                id="email"
                name="email"
                placeholder="email@email.com"
                value={data.email}
              />
            </div>
            <div className="Input-error-box">
              {errors.email && touched.email ? <div>{errors.email}</div> : null}
            </div>
            <div className="Input-Edit-box">
              <label htmlFor="phone">Teléfono</label>
              <Field
                id="phone"
                name="phone"
                type="tel"
                placeholder="123 456 789"
                value={data.phone}
              />
            </div>
            <div className="Input-error-box">
              {errors.phone && touched.phone ? <div>{errors.phone}</div> : null}
            </div>
            <div className="Input-Edit-box">
              <label htmlFor="date">Teléfono</label>
              <Field
                id="date"
                name="date"
                type="text"
                placeholder="13/01/2023"
                value={data.date}
              />
            </div>
            <div className="Input-error-box">
              {errors.date && touched.date ? <div>{errors.date}</div> : null}
            </div>

            <div className="Input-Edit-box">
              <label htmlFor="_id">Id</label>
              <Field
                id="_id"
                name="_id"
                type="text"                
                value={data._id}
              />
            </div>
            <div className="Input-error-box">
              {errors._id && touched._id ? <div>{errors._id}</div> : null}
            </div>

            <div className="Button-box">
              <button type="submit">Actualizar</button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default EditForm;
